import React from 'react';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Me dio claridad justo cuando más la necesitaba.',
    author: 'Mamá en Texas',
    highlight: false
  }, {
    text: 'Por fin sentí que tenía un plan en vez de improvisar.',
    author: 'Mamá en Florida',
    highlight: true
  }, {
    text: 'Lo leí rápido y supe qué hacer en una crisis real.',
    author: 'Mamá en USA',
    highlight: false
  }];
  return <section className="bg-[#FDF8F0] py-14 md:py-20 px-5" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <h2 className="text-xl md:text-2xl font-bold text-[#2D1F0E] text-center mb-10" data-id="element-181">
          Lo que otras mamás valoran de esta guía
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-id="element-182">
          {testimonials.map((t, idx) => <div key={idx} className={`rounded-2xl p-6 md:p-7 ${t.highlight ? 'bg-white border-2 border-[#4A6741]/25 shadow-md' : 'bg-white border border-[#D4A853]/15 shadow-sm'}`} data-id="element-183">
              <Quote className={`w-5 h-5 mb-3 ${t.highlight ? 'text-[#4A6741]' : 'text-[#D4A853]'}`} data-id="element-184" />
              <p className="text-[#2D1F0E] text-base md:text-lg italic leading-relaxed mb-4" data-id="element-185">
                {t.text}
              </p>
              <p className="text-[#6B5D4F] text-sm md:text-base font-medium" data-id="element-186">
                — {t.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}